import React, { Component, Fragment } from 'react';
import Modal from 'react-modal';
import moment from 'moment';
import PropTypes from 'proptypes';
import ItineraryModal from '../forms/ItineraryModal';
import logo from './../../../assets/give-facebook.svg';
import './ImportantInfo.scss';

//TODO: change Cultural Considerations && Student Group Link links from https://www.givevolunteers.org/ to actual links

export default class ImportantInfo extends Component {
  state = {
    activeModal: null,
  };

  openModal = () => {
    this.setState({
      activeModal: 'itineraryModal',
    });
  };

  closeModal = () => {
    this.setState({
      activeModal: null,
    });
  };

  render() {
    const {
      tripFBGroup,
      startDate,
      allDocumentsUploaded,
      tripId,
      mailingCountry,
      // tripDestination,
      // tripAddons,
      flightStatus,
    } = this.props;

    const facebookLink = tripFBGroup.replace(/.*._blank">/g, '').replace(/<\/a>/g, '');

    const countDownInDays = moment().diff(startDate, 'days');

    const countDownInMonths = moment().diff(startDate, 'months');

    let handbookAndPackagingLink = 'https://www.givevolunteers.org/trip-handbooks/';
    let culturalConsiderationLink = 'https://www.givevolunteers.org/trip-handbooks/';

    let addOnName = '';
    let addOnHandbookLink = '';

    // if (tripDestination === "Loas") {
    //   handbookAndPackagingLink =
    //     "https://s3.amazonaws.com/give-portal/public/trip/overview/Laos-Excursion-Overview-Winter-2019.pdf";
    //   culturalConsiderationLink =
    //     "https://s3.amazonaws.com/give-portal/public/trip/overview/Laos-Cultural-Considerations.pdf";
    // } else if (tripDestination === "Thailand") {
    //   handbookAndPackagingLink =
    //     "https://s3.amazonaws.com/give-portal/public/trip/overview/Thailand-Excursion-Overview-W2019.pdf";
    //   culturalConsiderationLink =
    //     "https://s3.amazonaws.com/give-portal/public/trip/overview/thailand_cultural_considerations.pdf";
    // } else if (tripDestination === "Tanzania") {
    //   handbookAndPackagingLink =
    //     "https://www.givevolunteers.org/trip-handbooks/#handbook-tanzania";
    //   culturalConsiderationLink =
    //     "https://s3.amazonaws.com/give-portal/public/trip/overview/Tanzania-Cultural-Considerations.pdf";
    // } else if (tripDestination === "USA: Hawaii") {
    //   handbookAndPackagingLink =
    //     "https://www.givevolunteers.org/wp-content/uploads/Hawaii-Excursion-Overview-S2021.pdf";
    // } else if (
    //   tripDestination === "Nepal & Everest Volunteer Package" ||
    //   "Nepal" ||
    //   "Nepal Tibetan Frontier"
    // ) {
    //   handbookAndPackagingLink =
    //     "https://s3.amazonaws.com/give-portal/public/trip/overview/Nepal-Excursion-Overview-W2018.pdf";
    //   culturalConsiderationLink =
    //     "https://s3.amazonaws.com/give-portal/public/trip/overview/Nepal-Cultural-Considerations-2019.pdf";
    //   if (tripDestination === "Nepal & Everest Volunteer Package") {
    //     addOnName = "Everest Base Camp Trek Overview";
    //     addOnHandbookLink =
    //       "https://s3.amazonaws.com/give-portal/public/trip/overview/Everest-Base-Camp-Trek-Overview-Winter-2019.pdf";
    //   }
    // }

    // for (let i = 0; i < tripAddons.length; i++) {
    //   let tripAddonsArr = [];
    //   tripAddonsArr.push(tripAddons[i].name.split(" ").shift());
    //   if (tripAddonsArr.includes("Kilimanjaro")) {
    //     addOnName = "Mt. Kilimanjaro Trek Overview";
    //     addOnHandbookLink =
    //       "https://s3.amazonaws.com/give-portal/public/trip/overview/Mt-Kilimanjaro-Overview-Summer-2018.pdf";
    //   }
    // }

    return (
      <div className="important-info">
        <h4 className="h1-style muted">
          Important Info{' '}
          {countDownInMonths > -4 && allDocumentsUploaded !== tripId ? (
            <span className="icon-container warning-icon" />
          ) : (
            ''
          )}
        </h4>
        <ul>
          <li>
            <p className="extra-small no-margin-text">
              <a
                href="https://go.givevolunteers.org/generaltripoverview"
                target="_blank"
                rel="noopener noreferrer"
                className="small-link"
              >
                General Trip Overview
              </a>
            </p>
          </li>
          <li>
            {/* {countDownInMonths > -4 && allDocumentsUploaded !== tripId ? (
              <p className="no-margin-text warning smaller">
                Your trip is coming up soon. Please{" "}
                <button
                  onClick={this.openModal}
                  className="btn-plain-text btn-error"
                >
                  CONTACT
                </button>{" "}
                our flight agents asap if you haven&#39;t done so already!
              </p>
            ) : (
              ""
            )} */}
            <Fragment>
              <p className="no-margin-text muted">Flight Status</p>
              {flightStatus.toLowerCase().includes('confirmed') ? (
                <p className="no-margin-text muted">
                  <button onClick={this.openModal} className="btn-plain-text small underline">
                    {flightStatus}
                  </button>{' '}
                </p>
              ) : (
                <p className="small no-margin-text">{flightStatus}</p>
              )}
            </Fragment>
          </li>
          <li>
            {facebookLink.length > 1 ? (
              <div className="facebook-container">
                <a
                  href={facebookLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="small-link"
                >
                  <img src={logo} alt="facebook-logo" width="30" height="30" />
                  Facebook Group
                </a>
              </div>
            ) : (
              ''
            )}
          </li>
          <li>
            {countDownInDays >= -30 ? (
              <p className="extra-small no-margin-text">
                <a
                  href={handbookAndPackagingLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="small-link"
                >
                  Handbook + Packing List
                </a>
              </p>
            ) : (
              <Fragment>
                <p className="no-margin-text muted">Handbook + Packing List</p>
                <p className="extra-small no-margin-text">
                  Link available 30 days before your trip
                </p>
              </Fragment>
            )}
          </li>
          <li>
            {countDownInDays >= -30 ? (
              <Fragment>
                {culturalConsiderationLink ? (
                  <p className="extra-small no-margin-text">
                    <a
                      href={culturalConsiderationLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="small-link"
                    >
                      Cultural Considerations
                    </a>
                  </p>
                ) : (
                  ''
                )}
              </Fragment>
            ) : (
              <Fragment>
                <p className="no-margin-text muted">Cultural Considerations</p>
                <p className="extra-small no-margin-text">
                  Link available 30 days before your trip
                </p>
              </Fragment>
            )}
          </li>
          {addOnName.length ? (
            <li>
              {countDownInDays >= -30 ? (
                <p className="extra-small no-margin-text">
                  <a
                    href={addOnHandbookLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="small-link"
                  >
                    {addOnName}
                  </a>
                </p>
              ) : (
                <Fragment>
                  <p className="no-margin-text muted">{addOnName}</p>
                  <p className="extra-small no-margin-text">
                    Link available 30 days before your trip
                  </p>
                </Fragment>
              )}
            </li>
          ) : (
            ''
          )}
        </ul>
        <Modal
          isOpen={this.state.activeModal === 'itineraryModal'}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <ItineraryModal mailingCountry={mailingCountry} closeModal={this.closeModal} />
        </Modal>
      </div>
    );
  }
}

ImportantInfo.propTypes = {
  tripFBGroup: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  tripId: PropTypes.string.isRequired,
  mailingCountry: PropTypes.string.isRequired,
  allDocumentsUploaded: PropTypes.bool,
  flightStatus: PropTypes.string,
};

ImportantInfo.defaultProps = {
  allDocumentsUploaded: true,
};
